/**
 * Whether a request failed because the server said "too many requests".
 *
 * The service error classes (`DealScreeningRequestError`,
 * `MonitoringRequestError`) carry the HTTP status; a 429 is the one failure
 * a poller must NOT retry on its own schedule, because every retry counts
 * against the budget that is already spent.
 */
export const HTTP_TOO_MANY_REQUESTS = 429;

export function isRateLimited(error: unknown): boolean {
	return (
		error instanceof Error &&
		"status" in error &&
		(error as { status?: unknown }).status === HTTP_TOO_MANY_REQUESTS
	);
}
